import type { IncomeInformationStepFormData } from "Components/Onboarding/BusinessEntity/Steps/IncomeInformationStep/schema";
import { SharedBusinessFields } from "Components/Onboarding/BusinessEntity/Steps/IncomeInformationStep/SharedBusinessFields";
import { PoliticallyExposedCheckbox } from "Components/Onboarding/shared/PoliticallyExposedCheckbox";
import { CountryDropdown } from "Components/Shared/Inputs/Form/Dropdowns/CountryDropdown";
import { GroupedRelationTypeSelector } from "Components/Shared/SelectorsForm/GroupedRelationTypeSelector";
import {
  type BusinessActivity,
  PartyType,
  type SourceOfIncome,
} from "Infrastructure/Api/Api";
import type { Control } from "react-hook-form";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES =
  Resources.Onboarding.BusinessOnboarding.Steps.IncomeInformation.Fields;

type Props = {
  control: Control<IncomeInformationStepFormData>;
  businessActivity?: BusinessActivity;
  sourcesOfIncome: Array<SourceOfIncome>;
  partyType?: PartyType;
  isPoliticallyExposedPerson: boolean;
};

export const HunterIncomeInformationFields = ({
  control,
  businessActivity,
  sourcesOfIncome,
  partyType,
  isPoliticallyExposedPerson,
}: Props) => {
  const { t } = useResource();

  return (
    <>
      <SharedBusinessFields
        control={control}
        sourcesOfIncome={sourcesOfIncome}
        businessActivity={businessActivity}
      />
      <CountryDropdown
        control={control}
        name="taxResidency"
        label={t(COMPONENT_RESOURCES.TaxResidencyCountry)}
      />
      {partyType === PartyType.LegalEntity && (
        <GroupedRelationTypeSelector
          control={control}
          name="relationType"
          label={t(COMPONENT_RESOURCES.RelationType)}
        />
      )}
      <PoliticallyExposedCheckbox
        control={control}
        name="isPoliticallyExposedPerson"
        isChecked={isPoliticallyExposedPerson}
      />
    </>
  );
};
